import React from "react";

import { JourneyChart } from "components/views/patientDetails/ui/journeyChart";

import step1 from "./assets/issue/step-1.svg";
import step2 from "./assets/issue/step-2.svg";
import step3 from "./assets/issue/step-3.svg";

export const IssueDeviceView: React.FC<{ actions: React.ReactElement }> = ({ actions }) => {
  return (
    <JourneyChart>
      <JourneyChart.Title>Delivery Process</JourneyChart.Title>
      <JourneyChart.Steps>
        <JourneyChart.Step imgSrc={step1}>The device will be delivered to the patient within 7 days</JourneyChart.Step>
        <JourneyChart.Step imgSrc={step2}>
          The patient will be trained to use the Entia Liberty device
        </JourneyChart.Step>
        <JourneyChart.Step imgSrc={step3}>Results are displayed in the Entia Liberty Patient List</JourneyChart.Step>
      </JourneyChart.Steps>
      <JourneyChart.Actions>{actions}</JourneyChart.Actions>
    </JourneyChart>
  );
};
